import {memo} from 'react';
import type {ReactNode} from 'react';
import styles from './IconTile.module.scss';

interface IconTileProps {
    children: ReactNode;
    className?: string;
}

/**
 * Plain stand-in for home-services' CommonImageWrapper: the site-wide 46×46 blue-gradient icon tile. Keeps the
 * `common-icon-tile` class, which Card's blue hover targets.
 */
const IconTile = ({children, className}: IconTileProps) => (
    <div className={['common-icon-tile', styles.tile, className].filter(Boolean).join(' ')}>{children}</div>
);

export default memo(IconTile);
